import React, { FC } from 'react';

import { WindowWidthContext } from '@minecraft.utils';
import { AddPaymentProps } from './types';
import { Purchase } from '../types';
import { AddPaymentMethod } from './AddPaymentMethod';
import { PaymentAndPlanDetails } from './PaymentAndPlanDetails';
import { SelectPlanSm } from './SelectPlanSm';

export const AddPayment: FC<AddPaymentProps & { isRegistration?: boolean; disableTrial?: boolean }> = React.memo(
  ({
    addPaymentError,
    addPaymentLoading,
    onAddPaymentOption,
    threeDActionContext,
    onThreeDActionError,
    currencyCode,
    countryCode,
    paywallLocation,
    allowCancel,
    onCompletePurchase,
    selectedPlan,
    currentPurchase,
    completedPurchase,
    completePurchaseLoading,
    completePurchaseError,
    selectedPaymentOption,
    wallet,
    onSelectPaymentOption,
    onNext,
    onCancel,
    setIsAnnual,
    isAnnual,
    plans,
    setSelectedPlan,
    onPaymentCompleteRedirect,
    isRegistration = false,
    disableTrial = false,
    onApplyCoupon,
    couponLoading,
    applyCouponError,
    onRemoveCoupon,
  }) => {
    const isMobile = WindowWidthContext.useIsMobile();
    if (isRegistration) {
      return (
        <>
          {isMobile && (
            <SelectPlanSm
              plans={plans}
              setSelectedPlan={setSelectedPlan}
              selectedPlan={selectedPlan}
              loading={!selectedPlan || addPaymentLoading}
            />
          )}
          <PaymentAndPlanDetails
            onCancel={onCancel}
            addPaymentError={addPaymentError}
            addPaymentLoading={addPaymentLoading}
            wallet={wallet}
            allowCancel={allowCancel}
            onAddPaymentOption={onAddPaymentOption}
            threeDActionContext={threeDActionContext}
            onThreeDActionError={onThreeDActionError}
            currencyCode={currencyCode}
            countryCode={countryCode}
            paywallLocation={paywallLocation}
            onCompletePurchase={onCompletePurchase}
            plans={plans}
            selectedPlan={selectedPlan}
            currentPurchase={currentPurchase as Purchase}
            completePurchaseError={completePurchaseError}
            selectedPaymentOption={selectedPaymentOption}
            onSelectPaymentOption={onSelectPaymentOption}
            onNext={onNext}
            completedPurchase={completedPurchase}
            completePurchaseLoading={completePurchaseLoading}
            setIsAnnual={setIsAnnual}
            isAnnual={isAnnual}
            onPaymentCompleteRedirect={onPaymentCompleteRedirect}
            disableTrial={disableTrial}
            onApplyCoupon={onApplyCoupon}
            couponLoading={couponLoading}
            applyCouponError={applyCouponError}
            onRemoveCoupon={onRemoveCoupon}
          />
        </>
      );
    }

    return (
      <AddPaymentMethod
        onNext={onNext}
        onCancel={onCancel}
        addPaymentError={addPaymentError}
        addPaymentLoading={addPaymentLoading}
        allowCancel={allowCancel}
        onAddPaymentOption={onAddPaymentOption}
        onCompletePurchase={onCompletePurchase}
        threeDActionContext={threeDActionContext}
        onThreeDActionError={onThreeDActionError}
        currencyCode={currencyCode}
        countryCode={countryCode}
        paywallLocation={paywallLocation}
      />
    );
  }
);
